module.exports = __webpack_public_path__ + "img/w3_circle_left_grey.22042139.png";